import { I18n } from '@/i18n/I18n';
import { FixtureResult } from '@/reports/bundles/types';
import { Badge } from '../ui/badge';

/**
 * The bundle's fixtures — contexts under `fixtures/` it is evaluated against
 * on every compile — and what each came to. A fixture that states what it
 * expects and misses it holds the bundle back from publishing.
 */
export function BundleFixtures({ results, onSelect }: { results: FixtureResult[]; onSelect: (file: string) => void }) {
  if (results.length === 0) {
    return <p className="px-3 py-2 text-xs text-muted-foreground">{I18n.get('reportBundleNoFixtures')}</p>;
  }
  return (
    <ul aria-label={I18n.get('reportBundleFixtures')} className="divide-y text-xs">
      {results.map((r) => (
        <li key={r.file} className="flex flex-wrap items-baseline gap-2 px-3 py-1.5">
          <Badge variant={r.ok ? 'outline' : 'destructive'} className={r.ok ? 'h-4 px-1.5 text-[0.65rem] text-emerald-700' : 'h-4 px-1.5 text-[0.65rem]'}>{r.ok ? 'OK' : 'FAIL'}</Badge>
          <button type="button" className="font-mono text-primary hover:underline" onClick={() => onSelect(r.file)}>{r.file}</button>
          <span>{r.verdictLabel ?? '—'}{r.expected ? <span className="text-muted-foreground"> · {I18n.get('reportBundleFixtureExpects', { expected: r.expected.verdictLabel ?? r.expected.verdict ?? '' })}</span> : null}</span>
          {r.error && <span className="text-destructive">{r.error}</span>}
        </li>
      ))}
    </ul>
  );
}
